import { useState } from "react";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import { AttributeFieldProps } from "./RenderAttributeInput";
import ColorInputField from "./ColorInputField";
import GradientBuilder from "../Menus/GraidentBuilder";


enum OverlayType{
    None,
    Color,
    Gradient

}

export default function OverlayField(props:AttributeFieldProps){

    let val = GetComponentOrStyleValueFromDefinition(props.definition,props.layoutObject,props.screenSize);

    let type = OverlayType.None;
    if(val.length>1){
        if(val.includes("gradient"))
            type = OverlayType.Gradient;
        else
            type = OverlayType.Color;
    }
    const [overlayType,setOverlayType] = useState(type);

    const updateOverlayType = (newType:OverlayType)=>{
        setOverlayType(newType);

        if(newType == OverlayType.Gradient)
            props.updateFunc(props.definition.attKey,"linear-gradient(180deg, #ffffff44 0%, #00000044 100%)",props.definition.targetType);
        else if(newType == OverlayType.Color)
            props.updateFunc(props.definition.attKey,"#00000044",props.definition.targetType);
        else{
            props.updateFunc(props.definition.attKey,"",props.definition.targetType);
        }
    }
    return (

        <div className="wb-input-group">
       <label>Overlay</label>
           

            <div className="wb-input-row">
            <button className={"invisible-button "+(overlayType==OverlayType.None?"selected":"")}
                onClick={()=>{updateOverlayType(OverlayType.None)}}
                >None
                </button>
                <button className={"invisible-button "+(overlayType==OverlayType.Color?"selected":"")}
                onClick={()=>{updateOverlayType(OverlayType.Color)}}
                >Color
                </button>

                <button className={"invisible-button "+(overlayType==OverlayType.Gradient?"selected":"")}
                onClick={()=>{updateOverlayType(OverlayType.Gradient)}}
                >Gradient
                </button>
            

            </div>
     
          

            {overlayType == OverlayType.Gradient&& <GradientBuilder siteData={props.siteData} useOpacity={true} inGradient={val} onUpdateGradient={(newGradient)=>{ props.updateFunc(props.definition.attKey,newGradient,props.definition.targetType);}} />}
           
            {overlayType == OverlayType.Color&&<ColorInputField {...props} label={""} />}

            

        </div>



    )


}